document.addEventListener("DOMContentLoaded", () => {
    const hamburger = document.querySelectorAll('.JS-hamburger'),
        menu = document.querySelector('.responsive-menu-holder'),
        clone = document.querySelector('.efect-clone'),
        anchors = document.querySelectorAll('.PR-anchor');

    menu.querySelectorAll('.uroven-2').forEach(el => {
        const anchor = document.createElement('span');
        el.parentNode.insertBefore(anchor, el.parentNode.firstChild);
        el.parentNode.firstChild.classList.add("PR-anchor");
    });

    [...hamburger, clone].forEach(el => {
        el.addEventListener('click', () => {
            hamburger.forEach(eachHamburger => {
                eachHamburger.classList.toggle('is-active');
            });

            menu.classList.toggle('is-active');
            document.body.classList.toggle('no-scroll');
            anchors.forEach(anchor => { anchor.classList.remove('is-active') });
        });
    });

    menu.querySelectorAll('.PR-anchor').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            el.classList.toggle('is-active');
            el.parentElement.classList.toggle('is-active');
            el.nextElementSibling.nextElementSibling.classList.toggle('is-active');
        });
    });

    // První varianta vyjímka
    //=======================
    const menuVariant1 = document.querySelectorAll('.variant-1');
    if (typeof(menuVariant1) != 'undefined' && menuVariant1 != null)
        menuVariant1.forEach(el => {
            el.addEventListener('click',() => { animJs.slideToggle(el.nextElementSibling) });
        });

    // Folding nav
    //============
    const foldingNav = () => {
        const menuHolder = document.querySelector('.JS-menu ul#menu'),
            foldingNavContainer = foldingNavHolder.querySelector('[data-folding-nav-items]');

        foldingNavContainer.innerHTML = "";
        if (Array.from(hamburger).some(el => getComputedStyle(el).display !== 'none')) { // mobile layout reset
            foldingNavHolder.classList.remove('is-visible');
            return;
        }

        if (menuHolder.firstElementChild && menuHolder.clientHeight > menuHolder.firstElementChild.clientHeight) {
            foldingNavHolder.classList.add('is-visible');
        } else {
            foldingNavHolder.classList.remove('is-visible');
        }

        menuHolder.childNodes.forEach(link => {
            if (link.offsetTop !== menuHolder.firstElementChild.offsetTop)
                foldingNavContainer.append(link.cloneNode(true));
        })
    }

    const foldingNavHolder = document.querySelector('[data-folding-nav]');
    foldingNavHolder && foldingNav();

    // Reset pri resizu
    //=================
    window.addEventListener('resize', () => {
        foldingNavHolder && foldingNav();
        menu.querySelectorAll('.uroven-2').forEach(el => { el.style.display = '' });
        menu.querySelectorAll('li').forEach(el => { el.classList.remove('is-active') });
        anchors.forEach(el => { el.classList.remove('is-active') });
    });
});